import { FC, useMemo } from 'react';
import React from 'react';
import SummaryRowsDesktop from './SummaryRowsDesktop';

import {
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ComposedChart,
} from 'recharts';
import Color from 'constants/Color';
import ColorDotTooltip from 'components/charts/ColorDotTooltip';
import { toShortSweNumber } from 'utils/numbers';
import {
  GraphWrapper,
  MyCustomLegend,
  BulletInfoText,
  DashboardGridItem,
  tickSize,
  yAxisWidth,
} from '../../components/components';
import { DashboardStats } from 'api';
import DashboardGridItemHeader from '../../components/DashboardGridItemHeader';

interface Props {
  stats: DashboardStats;
}

const YearlyJobs: FC<Props> = ({ stats }) => {
  const yearlyStats = useMemo(() => {
    return stats.yearlyStats
      .sort((a, b) => a.year - b.year)
      .map((ms) => ({
        year: ms.year,
        År: Math.round(ms.totalSalesPrice.value),
        Projektion: Math.round(ms.projectedAdditionalSalesPrice),
        towings: ms.completedTowingCount.value,
        heavyTowings: ms.heavyVehiclesCount.value,
        invoicedTowings: ms.invoicedTowingCount.value,
      }));
  }, [stats.yearlyStats]);

  return (
    <>
      <GraphWrapper>
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart
            data={yearlyStats}
            barGap={0}
            maxBarSize={50}
            barCategoryGap={'20%'}
            margin={{ top: 20 }}
          >
            <Tooltip
              animationDuration={200}
              content={<ColorDotTooltip unit="kr" />}
            />
            <CartesianGrid vertical={false} strokeDasharray="3 3" />

            <defs>
              <pattern
                id="stripes-background"
                width="4"
                height="10"
                patternUnits="userSpaceOnUse"
                patternTransform="rotate(45 50 50)"
              >
                <line stroke={Color.chart.a.dark} strokeWidth="4px" y2="10" />
              </pattern>
            </defs>
            <Bar dataKey="År" fill={Color.chart.a.light} stackId="projection" />
            <Bar
              dataKey="Projektion"
              stackId="projection"
              fill="url(#stripes-background)"
            />

            <XAxis tickSize={tickSize} dataKey="year" />
            <YAxis
              width={yAxisWidth}
              tickSize={tickSize}
              tickFormatter={(v) =>
                typeof v === 'number' ? toShortSweNumber(v, 1) : v
              }
            />
            <Legend content={<MyCustomLegend />} />
          </ComposedChart>
        </ResponsiveContainer>
      </GraphWrapper>

      {yearlyStats ? (
        <SummaryRowsDesktop
          rows={[...yearlyStats]
            .sort((a, b) => b.year - a.year)
            .map((mi) => ({
              title: mi.year.toString(),
              money: mi.År,
              towings: mi.towings,
              heavyTowings: mi.heavyTowings,
              invoicedTowings: mi.invoicedTowings,
            }))}
        />
      ) : null}
    </>
  );
};

export default YearlyJobs;
